import { render, staticRenderFns } from "./CategoryCreateForm.vue?vue&type=template&id=69be464c&"
import script from "./CategoryCreateForm.vue?vue&type=script&lang=js&"
export * from "./CategoryCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports